"use strict";

exports.__esModule = true;
var _DashboardNavbar = require("./DashboardNavbar");
Object.keys(_DashboardNavbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardNavbar[key]) return;
  exports[key] = _DashboardNavbar[key];
});